// removed by extract-text-webpack-plugin
module.exports = {"container":"_3hZFF _7mR3c","title":"_1ps-K","categories":"_2mztb","maxHeight":"_22NYQ","subCategoryLinks":"_1vwU8","parent":"_3Hw_s","child":"_3JNFG"};


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/CategoryListContainer/index.sass
// module id = 1519
// module chunks = 1